/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The CampaignRunDataSend model module.
 * @module model/CampaignRunDataSend
 * @version 1.0.0
 */
export class CampaignRunDataSend {
  /**
   * Constructs a new <code>CampaignRunDataSend</code>.
   * @alias module:model/CampaignRunDataSend
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CampaignRunDataSend</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CampaignRunDataSend} obj Optional instance to populate.
   * @return {module:model/CampaignRunDataSend} The populated <code>CampaignRunDataSend</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CampaignRunDataSend();
      if (data.hasOwnProperty('dataset'))
        obj.dataset = ApiClient.convertToType(data['dataset'], 'String');
      if (data.hasOwnProperty('table'))
        obj.table = ApiClient.convertToType(data['table'], 'String');
      if (data.hasOwnProperty('size'))
        obj.size = ApiClient.convertToType(data['size'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {String} dataset
 */
CampaignRunDataSend.prototype.dataset = undefined;

/**
 * @member {String} table
 */
CampaignRunDataSend.prototype.table = undefined;

/**
 * @member {Number} size
 */
CampaignRunDataSend.prototype.size = undefined;

